import { Component, Input, OnInit } from '@angular/core';
import { TournamentService } from 'src/app/modules/tournament/tournament.service';

@Component({
    selector: 'app-shared-tournament-enroll',
    templateUrl: './shared-tournament-enroll.component.html',
    styleUrls: ['./shared-tournament-enroll.component.scss'],
})
export class SharedTournamentEnrollComponent implements OnInit {
    @Input() categoryId: string;
    @Input() tournamentId: string;

    constructor(private tournamentService: TournamentService) {}

    ngOnInit(): void {
        // this.getEnrollments();
    }
}
